<script>
    export let url = "";
    export let separator = "|";
    export let timer = '500';
    export let parse_catalog = true;
    export let parse_category = false;
    export let parse_product = false;

    export let change_url;
</script>

<div class="section-title">Общие настройки</div>
<div class="wide-block pb-2">
    <div class="row">
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Точка старта <span class="text-danger">*</span></span>
                    <input type="url" class="form-control" placeholder="http://example.com/catalog" bind:value={url} on:change={() => change_url(url)}/>
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Делитель (csv)</span>
                    <input type="text" class="form-control" bind:value={separator} />
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Задержка запросов</span>
                    <input type="number" class="form-control" bind:value={timer} />
                </div>
            </div>
        </div>
        <div class="col-12 text-center mt-1">
            <div class="form-check">
                <input type="checkbox" class="form-check-input" id="parse_catalog" bind:checked={parse_catalog} on:click={() => {parse_catalog = !parse_catalog}}>
                <label class="form-check-label" for="parse_catalog">Обход каталога</label>
            </div>
        </div>
        <div class="col-12 text-center mt-1">
            <div class="form-check">
                <input type="checkbox" class="form-check-input" id="parse_category" bind:checked={parse_category} on:click={() => {parse_category = !parse_category}}>
                <label class="form-check-label" for="parse_category">Обход продуктов</label>
            </div>
        </div>
        {#if parse_category}
            <div class="col-12 text-center mt-1">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="parse_product" bind:checked={parse_product} on:click={() => {parse_product = !parse_product}}>
                    <label class="form-check-label" for="parse_product">Обход продуктов по страницам</label>
                </div>
            </div>
        {/if}
    </div>
</div>
